export default __webpack_public_path__ + "static/media/main.280766c2.png";